<template>
  <div>
    <Comments
      :comments="comments"
      @comment-edit="handleCommentEdit"
      @comment-delete="handleCommentDelete"
      @comment-reply="handleCommentReply"
      @save-comment="handleSaveComment"
      @save-edit-comment="handleSaveEditComment"
      @cancel-edit="handleCancelEdit"
      @cancel-reply="handleCancelReply"
      @save-reply-comment="handleSaveReplyComment"
      @delete-reaction="handleDeleteReaction"
      @change-reaction="handleChangeReaction"
      @save-reaction="handleSaveReaction"
      @toggle-comment-mark="onToggleCommentMark"
    />

    <DeleteConfirmationModal
      id="modalKommentarLoeschen"
      title="Kommentar löschen?"
      entityBezeichnung="der Kommentar"
      @confirm="confirmDeleteComment"
    />
  </div>
</template>
<script>
import Comments from '@/components/comments/comments.vue';
import DeleteConfirmationModal from '@/components/common/delete-confirmation-modal.vue';
import {
  SAVE_REPLY_COMMENT,
  SET_MODE,
  SET_COMMENT_TEXT,
  SET_EDIT_COMMENT_ID,
  SET_REPLY_COMMENT_ID,
  SAVE_EDIT_COMMENT,
  DELETE_COMMENT,
  SAVE_COMMENT,
  DELETE_REACTION,
  SAVE_REACTION,
  CHANGE_REACTION,
  TOGGLE_MARK_COMMENT,
} from '@/core/comments/comments.module';

export default {
  components: { Comments, DeleteConfirmationModal },
  props: { comments: { type: Array }, aufgabeId: { type: Number } },
  data() {
    return {
      pendingDeleteCommentId: null,
    };
  },
  methods: {
    handleSaveComment() {
      this.$store
        .dispatch(SAVE_COMMENT, { isAufgabenComments: true, aufgabeId: this.aufgabeId })
        .then(res => {
          this.toast('Kommentar wurde gespeichert.');
          this.$emit('updateComments', res);
        });
      this.$store.commit(SET_COMMENT_TEXT, '');
    },
    handleCommentDelete(commentId) {
      this.pendingDeleteCommentId = commentId;
      this.$bvModal.show('modalKommentarLoeschen');
    },
    confirmDeleteComment() {
      const commentId = this.pendingDeleteCommentId;
      this.$bvModal.hide('modalKommentarLoeschen');
      if (commentId == null) return;
      this.$store
        .dispatch(DELETE_COMMENT, {
          commentId,
          isAufgabenComments: true,
          aufgabeId: this.aufgabeId,
        })
        .then(res => {
          this.$emit('updateComments', res);
          this.toast('Kommentar wurde gelöscht.');
        });
      this.$store.commit(SET_COMMENT_TEXT, '');
      this.$store.commit(SET_MODE, '');
      this.$store.commit(SET_EDIT_COMMENT_ID, null);
      this.$store.commit(SET_REPLY_COMMENT_ID, null);
      this.pendingDeleteCommentId = null;
    },
    handleSaveReplyComment() {
      this.$store
        .dispatch(SAVE_REPLY_COMMENT, { isAufgabenComments: true, aufgabeId: this.aufgabeId })
        .then(res => {
          this.$emit('updateComments', res);
          this.toast('Antwort auf Kommentar wurde erstellt.');
        });
    },
    handleCommentReply(commentId) {
      this.$store.commit(SET_MODE, 'reply');
      this.$store.commit(SET_COMMENT_TEXT, '');
      this.$store.commit(SET_EDIT_COMMENT_ID, null);
      this.$store.commit(SET_REPLY_COMMENT_ID, commentId);
    },
    handleCancelReply() {
      this.$store.commit(SET_MODE, '');
      this.$store.commit(SET_COMMENT_TEXT, '');
      this.$store.commit(SET_REPLY_COMMENT_ID, null);
    },
    handleCancelEdit() {
      this.$store.commit(SET_MODE, '');
      this.$store.commit(SET_COMMENT_TEXT, '');
      this.$store.commit(SET_EDIT_COMMENT_ID, null);
    },
    handleSaveEditComment(commentText) {
      this.$store
        .dispatch(SAVE_EDIT_COMMENT, {
          commentText,
          isAufgabenComments: true,
          aufgabeId: this.aufgabeId,
        })
        .then(res => {
          this.$emit('updateComments', res);
          this.toast('Kommentar wurde geändert.');
        });
    },
    handleCommentEdit(commentId, commentText) {
      this.$store.commit(SET_COMMENT_TEXT, commentText);
      this.$store.commit(SET_MODE, 'edit');
      this.$store.commit(SET_REPLY_COMMENT_ID, null);
      this.$store.commit(SET_EDIT_COMMENT_ID, commentId);
    },
    handleDeleteReaction({ reactionCommentId }) {
      this.$store
        .dispatch(DELETE_REACTION, {
          commentId: reactionCommentId,
          isAufgabenComments: true,
          aufgabeId: this.aufgabeId,
        })
        .then(res => this.$emit('updateComments', res));
    },

    handleChangeReaction({ oldReactionCommentId, replyCommentId, emoji }) {
      this.$store
        .dispatch(CHANGE_REACTION, {
          commentId: oldReactionCommentId,
          isAufgabenComments: true,
          aufgabeId: this.aufgabeId,
          text: emoji,
          replyCommentId,
        })
        .then(res => this.$emit('updateComments', res));
    },

    handleSaveReaction({ replyCommentId, emoji }) {
      this.$store
        .dispatch(SAVE_REACTION, {
          text: emoji,
          replyCommentId,
          isAufgabenComments: true,
          aufgabeId: this.aufgabeId,
        })
        .then(res => this.$emit('updateComments', res));
    },
    onToggleCommentMark({ commentId }) {
      this.$store
        .dispatch(TOGGLE_MARK_COMMENT, {
          commentId,
          isAufgabenComments: true,
          aufgabeId: this.aufgabeId,
        })
        .then(res => this.$emit('updateComments', res));
    },
  },
};
</script>
